export default "__VITE_ASSET__7c209e67__"